import React from 'react';
import { Building2 } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-violet-600 flex items-center justify-center mx-auto mb-4">
          <Building2 size={32} className="text-white animate-pulse" />
        </div>
        <p className="text-blue-200">Loading FlipperPro...</p>
      </div>
    </div>
  );
}
